import { render, staticRenderFns } from "./WorkerView.vue?vue&type=template&id=37901a9f&scoped=true&"
import script from "./WorkerView.vue?vue&type=script&lang=js&"
export * from "./WorkerView.vue?vue&type=script&lang=js&"
import style0 from "./WorkerView.vue?vue&type=style&index=0&id=37901a9f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37901a9f",
  null
  
)

export default component.exports